import queryString from "query-string";
import { ref, computed, reactive } from "vue";
import useUtilities from "@/composables/useUtilities";

const loadingNfts = ref(false);
const theosMinted = ref(true);

const externalNftDataListToShow = ref([]);

const useProfilePanels = (store) => {
  const walletAddress = computed(
    () => store.getters["contracts/getAddressCardano"]
  );
  const userId = computed(() => store.getters["userProfile/getUser"].id);
  let params = {
    creator: walletAddress.value,
    page: 1,
    perPage: 6,
    orderBy: "id",
    orderDirection: "DESC",
  };
  const { toggle } = useUtilities();
  const filterStyle = {
    background: "#0B0B0B",
    border: "2px solid #2C2C2C",
  };
  const showing = ref("nfts");
  const showFilters = ref(false);
  const filters = reactive({
    filterSlotsAvailable: false,
    filterSlotsNotAvailable: false,
    filterHighestFloorPrice: false,
    filterLowestFloorPrice: false,
    filterOwned: false,
    filterCreated: false,
    filterPooled: false,
    filterNotPooled: false,
  });
  const toggleFilter = async (filter) => {
    filters[filter] = !filters[filter];
    const publicAddress = await store.dispatch("contracts/fetchAddress");
    params = {
      page: 1,
      perPage: 6,
      orderBy: "id",
      orderDirection: "DESC",
    };
    let isAnythingSelected = false;
    for (const [key, value] of Object.entries(filters)) {
      isAnythingSelected = isAnythingSelected || value;
      if (value) {
        switch (key) {
          case "filterCreated":
            params.creator = publicAddress;
            break;
          case "filterOwned":
            params.owner = publicAddress;
            break;
          case "filterPooled":
            break;
          case "filterNotPooled":
            break;
          case "filterHighestFloorPrice":
            break;
          case "filterLowestFloorPrice":
            break;
        }
      }
    }
    if (!isAnythingSelected) params.creator = publicAddress;
    store.dispatch("userProfile/clearNftDataList");
    store.dispatch("userProfile/clearExternalNftDataList");
    theosMinted.value
      ? await fetchNftList(queryString.stringify(params))
      : await fetchExternalNftList({ id: userId.value });
  };
  const searchString = ref("");
  const profilePanelNoItemsText = computed(() =>
    showing.value === "nfts"
      ? "This user is not the owner of any NFT at the moment."
      : "You're not part of any pool at the moment. Try creating your own."
  );
  const profilePanelNoItemsTextLineTwo = computed(
    () => "Try minting your own or purchasing one from the Pools Gallery."
  );
  const show = (value) => (showing.value = value);

  const nftsList = computed(() =>
    store.getters["userProfile/getByKey"]("nftsList")
  );
  const externalNftsList = computed(() =>
    store.getters["userProfile/getByKey"]("externalNftsList")
  );
  const poolsList = computed(() =>
    store.getters["userProfile/getByKey"]("poolsList")
  );
  const nftDataList = computed(() =>
    store.getters["userProfile/getByKey"]("nftDataList")
  );

  const externalNftDataList = computed(() =>
    store.getters["userProfile/getByKey"]("externalNftDataList")
  );

  const externalNftsToShowList = computed(() =>
    store.getters["userProfile/getByKey"]("externalNftsToShowList")
  );

  const fetchNftList = async (params) => {
    if (loadingNfts.value) return;
    loadingNfts.value = true;
    setTimeout(async () => {
      await store.dispatch("userProfile/fetchNftList", { params });
      loadingNfts.value = false;
    }, 1000);
  };

  const externalPage = ref(1);

  const setExternalPage = (value) => (externalPage.value = value);

  const fetchExternalNftList = async () => {
    loadingNfts.value = true;
    setTimeout(async () => {
      await store.dispatch("userProfile/fetchExternalNftList", {
        id: userId.value,
        page: externalPage.value,
      });
      loadingNfts.value = false;
    }, 500);
  };

  const fetchPoolsList = async (params) =>
    await store.dispatch("userProfile/fetchPools", { params });

  const clearNftList = () => store.dispatch("userProfile/clearNftList");

  const search = async () => {
    if (params.search !== searchString.value) {
      params = {
        creator: walletAddress.value,
        page: 1,
        perPage: 6,
        orderBy: "id",
        orderDirection: "DESC",
        status: "approved",
      };
      store.dispatch("userProfile/clearNftDataList");
      params.search = searchString.value;
      if (searchString.value === "") params.creator = walletAddress.value;
      theosMinted.value
        ? await fetchNftList(queryString.stringify(params))
        : await fetchExternalNftList(userId.value);
    }
  };

  const loadMore = async () => {
    params.page += 1;
    await fetchNftList(queryString.stringify(params));
  };

  const loadMoreExternal = async () => {
    externalPage.value += 1;
    await fetchExternalNftList({ id: userId.value, page: externalPage.value });
  };

  const theosMintedCheckboxIcon = () =>
    theosMinted.value
      ? require("@/Common/Icons/radio-minting-checked.png")
      : require("@/Common/Icons/radio-minting-unchecked.png");
  const otherPlatformsMintedCheckboxIcon = () =>
    theosMinted.value
      ? require("@/Common/Icons/radio-minting-unchecked.png")
      : require("@/Common/Icons/radio-minting-checked.png");

  const setTheosMinted = (val = true) => {
    if (!loadingNfts.value) theosMinted.value = val;
  };

  return {
    showing,
    show,
    profilePanelNoItemsText,
    profilePanelNoItemsTextLineTwo,
    searchString,
    filterStyle,
    filtersFlag: {
      showFilters,
    },
    filters,
    toggleFilter,
    toggle,
    nftsList,
    externalNftsList,
    poolsList,
    fetchNftList,
    fetchExternalNftList,
    clearNftList,
    fetchPoolsList,
    search,
    loadMore,
    loadMoreExternal,
    params,
    nftDataList,
    externalNftDataList,
    loadingNfts,
    theosMinted,
    theosMintedCheckboxIcon,
    otherPlatformsMintedCheckboxIcon,
    setTheosMinted,
    externalPage,
    setExternalPage,
    externalNftDataListToShow,
    externalNftsToShowList,
  };
};

export default useProfilePanels;
